import { BoxProps } from '@chakra-ui/react';

interface IOptions {
  isChecked: boolean;
  isDisabled: boolean;
}

export const getBoxStyles = ({ isChecked, isDisabled }: IOptions): BoxProps => {
  const baseStyles: BoxProps = {
    borderColor: 'primary.200',
    borderRadius: 6,
    borderStyle: 'solid',
    borderWidth: '1px',
  };

  if (isDisabled) {
    return {
      ...baseStyles,
      opacity: 0.2,
      backgroundColor: 'transparent',
      pointerEvents: 'none',
    };
  }

  if (isChecked) {
    return {
      ...baseStyles,
      borderColor: 'secondary.500',
    };
  }

  return baseStyles;
};
